export function isValidEmail(value: string): boolean {
  return /\S+@\S+\.\S+/.test(value);
}
